// react
import React from 'react';
import { FormattedMessage } from 'react-intl';

// third-party
import PropTypes from 'prop-types';

// application
import {
    Fi24Hours48Svg,
    FiFreeDelivery48Svg,
    FiPaymentSecurity48Svg,
    FiTag48Svg,
} from '../../svg';

export default function BlockFeatures(props) {
    const { layout } = props;

    return (
        <div className={`block block-features block-features--layout--${layout}`}>
            <div className="container">
                <div className="block-features__list">
                    <div className="block-features__item">
                        <div className="block-features__icon">
                            <FiFreeDelivery48Svg />
                        </div>
                        <div className="block-features__content">
                            <div className="block-features__title">
                                <FormattedMessage id="features.freeShipping" defaultMessage="Free Shipping" />
                            </div>
                            <div className="block-features__subtitle">
                                <FormattedMessage id="features.freeShippingSubtitle" defaultMessage="For orders from $50" />
                            </div>
                        </div>
                    </div>
                    <div className="block-features__divider" />
                    <div className="block-features__item">
                        <div className="block-features__icon">
                            <Fi24Hours48Svg />
                        </div>
                        <div className="block-features__content">
                            <div className="block-features__title">
                                <FormattedMessage id="features.support" defaultMessage="Support 24/7" />
                            </div>
                            <div className="block-features__subtitle">
                                <FormattedMessage id="features.supportSubtitle" defaultMessage="Call us anytime" />
                            </div>
                        </div>
                    </div>
                    <div className="block-features__divider" />
                    <div className="block-features__item">
                        <div className="block-features__icon">
                            <FiPaymentSecurity48Svg />
                        </div>
                        <div className="block-features__content">
                            <div className="block-features__title">
                                <FormattedMessage id="features.safety" defaultMessage="100% Safety" />
                            </div>
                            <div className="block-features__subtitle">
                                <FormattedMessage id="features.safetySubtitle" defaultMessage="Only secure payments" />
                            </div>
                        </div>
                    </div>
                    <div className="block-features__divider" />
                    <div className="block-features__item">
                        <div className="block-features__icon">
                            <FiTag48Svg />
                        </div>
                        <div className="block-features__content">
                            <div className="block-features__title">
                                <FormattedMessage id="features.hotOffers" defaultMessage="Hot Offers" />
                            </div>
                            <div className="block-features__subtitle">
                                <FormattedMessage id="features.hotOffersSubtitle" defaultMessage="Discounts up to 90%" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

BlockFeatures.propTypes = {
    layout: PropTypes.oneOf(['classic', 'boxed']),
};

BlockFeatures.defaultProps = {
    layout: 'classic',
};
